import { css } from '@emotion/css';
import { computed } from 'vue';

export const useStyles = () => {
  const baseClass = computed(() => css({
    '& > [class$="__body"]': {
      paddingBlock: 0,
    },
    '&__body': {
      display: 'flex',
      alignItems: 'center',
      gap: '2.5rem',
    },
    '&__body-text': {
      flex: 1,
    },
    '&__body-icon': {
      aspectRatio: '1 / 1',
      width: '3.5rem',
      height: 'auto',
    },
  }));

  return baseClass;
};
